// extracted by mini-css-extract-plugin
export default {"roundsTime":"RoundsTime_roundsTime__fyWa-","lnkText":"RoundsTime_lnkText__Wb2aM","lnk":"RoundsTime_lnk__XPyFI","icon":"RoundsTime_icon__OO3Os"};